export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: 'df1cdefd-a922-46fe-a136-dbba086aa2cc',
  },
  apiurl:'https://rs-etlapi-p.azurewebsites.net/',
  realizerUrl:'https://rs-realizerapi-p.azurewebsites.net/',
  scopes:'https://RemoteServiceADPROD.onmicrosoft.com/api/access_as_user',
  b2cConfig:{
    clientId:"e6d903f2-c4d9-4a5a-863c-9fa2f8f3215c",
    authority:'https://RemoteServiceADPROD.b2clogin.com/RemoteServiceADPROD.onmicrosoft.com/B2C_1A_signup_signin',
    authorityDomain:'RemoteServiceADPROD.b2clogin.com'
  }
};
